import { store } from 'router';
import { RootState } from 'reducers/rootReducer';
import { HeaderConfig } from 'apiManager/types';
import { DeployEnvironmentEnum, deployEnvironment } from './deploy';
import { accountManager } from 'utils/accountManager';

export const PAGE_SIZE = 15;

const DEPLOY_PROD_URL = 'https://domustudio.danea.it';
const DEPLOY_BETA_URL = 'https://beta-domustudio.danea.it';
export const DEPLOY_DEV_URL = 'https://dev-domustudio.danea.it';

const getDeployUrl = (branch: string) => {
  switch (branch) {
    case DeployEnvironmentEnum.Production:
      return DEPLOY_PROD_URL;
    case DeployEnvironmentEnum.Beta:
      return DEPLOY_BETA_URL;
    default:
      return DEPLOY_DEV_URL;
  }
};

const PROD_URL = 'https://domustudioapi.danea.it';
const BETA_URL = 'https://beta-domustudioapi.danea.it';
const DEV_URL = 'https://dev-domustudioapi.danea.it';

const getUrl = (branch: string) => {
  switch (branch) {
    case DeployEnvironmentEnum.Production:
      return PROD_URL;
    case DeployEnvironmentEnum.Beta:
      return BETA_URL;
    default:
      return DEV_URL;
  }
};

const OAUTH_SIGNAL_PROD_URL = 'https://auth.danea.it';
const OAUTH_SIGNAL_BETA_URL = 'https://auth.danea.it';
const OAUTH_SIGNAL_DEV_URL = 'https://dev-auth.danea.it';

const getOAuthSignalUrl = (branch: string) => {
  switch (branch) {
    case DeployEnvironmentEnum.Production:
      return OAUTH_SIGNAL_PROD_URL;
    case DeployEnvironmentEnum.Beta:
      return OAUTH_SIGNAL_BETA_URL;
    default:
      return OAUTH_SIGNAL_DEV_URL;
  }
};

export const DOMUSTUDIOAPI_BASE_PATH = getUrl(deployEnvironment);
export const DEPLOY_DOMUSTUDIO_BASE_PATH = getDeployUrl(deployEnvironment);
export const OAUTH_SIGNAL_SERVER_URL = getOAuthSignalUrl(deployEnvironment);

// TODO: make parameter mandatory
export const getAuthorizationHeader = (config?: HeaderConfig) => {
  const { accessToken, archiveId, avoidArchiveId, avoidContentTypeApplicationJson, avoidAuthorization } = config ?? {};
  const requestHeaders: { [key: string]: string } = {};
  const {
    authReducer: { accessToken: reduxAccessToken },
    generalReducer: { currentDb: reduxCurrentDb }
  } = store.getState() as RootState;

  if (!avoidAuthorization) {
    requestHeaders['authorization'] = `Bearer ${accessToken ?? reduxAccessToken}`;
  }
  if (archiveId) {
    requestHeaders['x-danea-domustudiodb'] = archiveId;
  }
  if (!avoidArchiveId && reduxCurrentDb) {
    requestHeaders['x-danea-domustudiodb'] = reduxCurrentDb.id;
  }
  if (!avoidContentTypeApplicationJson) {
    requestHeaders['content-type'] = 'application/json';
  }

  // Inject OAuth session ID header for TeamSystem ID-authenticated requests
  const oauthSessionId = accountManager.cookie.oauthSessionId.get();
  if (oauthSessionId) {
    requestHeaders['X-Session-Id'] = oauthSessionId;
  }

  return requestHeaders;
};
